import { Menu as MenuIcon } from "lucide-react";
import { useState } from "react";

export default function Header({ config }) {
  const [open, setOpen] = useState(false);
  const businessName = config?.business_name || "Cakesbyky";
  const links = [
    { href: "#menu", label: "Menu" },
    { href: "#book", label: "Book" },
    { href: "#about", label: "About" },
  ];

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-slate-100">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="header-logo">
          <img
            src="/cakesbyky-logo.png?v=2"
            alt={businessName}
            className="h-12 w-auto object-contain"
          />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-slate-600 hover:text-[color:var(--brand-navy)] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href="#book" className="btn-pill btn-navy text-sm" data-testid="header-book-btn">
            Book Now
          </a>
        </nav>
        <button className="md:hidden" onClick={() => setOpen(!open)} aria-label="Menu">
          <MenuIcon className="h-6 w-6 text-slate-700" />
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-100 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-slate-700 py-1"
              >
                {l.label}
              </a>
            ))}
            <a href="#book" onClick={() => setOpen(false)} className="btn-pill btn-navy text-center">
              Book Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
